export const initializeApp = (config = {}) => ({
  name: 'ybit-offline-app',
  options: config,
  offline: true
});

export default initializeApp;

